import * as types from './constants';

const initialState = {
  navbar: true,
  menu: true,
  loader: false,
  whiteBackground: false,
  criticalError: {
    status: null,
    headers: {}
  },
  message: ''
};

const actions = {
  [types.UPDATE_LAYOUT]: (state, { payload }) => {
    const data = {
      ...state,
      navbar: payload.navbar,
      menu: payload.menu,
      whiteBackground: payload.whiteBackground
    };

    return { ...data };
  },

  [types.SET_CRITICAL_ERROR]: (state, { payload }) => {
    const data = {
      ...state,
      criticalError: payload
    };

    return { ...data };
  },

  [types.UPDATE_MESSAGE]: (state, { payload }) => {
    const data = {
      ...state,
      message: payload
    };

    return { ...data };
  },

  [types.SHOW_LOADER]: state => {
    const data = {
      ...state,
      loader: true
    };

    return { ...data };
  },

  [types.HIDE_LOADER]: state => {
    const data = {
      ...state,
      loader: false
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};